<template>
  <div id="rateassist-breakpoints-tab-content">
    <div class="row">
      <div class="col-xs-12">
        <blockquote>
          Add a breakpoint
          <div class="btn btn-primary sq pull-right" @click="addRow">
            Add
          </div>
        </blockquote>
        <div class="col-xs-12 col-sm-6">
          <div class="form-group">
            <label class="form-label" for="bp-type">Breakpoint Type</label>
            <select v-model="breakpointsPer" id="bp-type" class="form-control">
              <option value=""></option>
              <option v-for="option in breakpoints" :value="option.id">{{ option.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-xs-12" v-for="(bp, i) in breakpointEntries">
          <div class="shadow clearfix">
            <hr class="hr-text" :data-content="`OPTION ${i + 1}`"/>
            <div class="col-xs-12 col-sm-6">
              <div class="form-group">
                <label :for="'bp-min-' + i" class="form-label">Minimum</label>
                <input type="number" step="0.01" class="form-control" :id="'bp-min-' + i" v-model="bp.minimumValue"/>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6">
              <div class="form-group">
                <label :for="'bp-max-' + i" class="form-label">Maximum</label>
                <input type="number" step="0.01" class="form-control" :id="'bp-max-' + i" v-model="bp.maximumValue"/>
              </div>
            </div>
            <div class="col-xs-12">
              <hr>
              <div class="pull-right">
                <div class="btn btn-danger" @click="remove(i)">
                  Delete
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LookupHelperMixin from '../../admin/mixins/Helpers'
  export default {
    name: 'Breakpoints',
    mixins: [ LookupHelperMixin ],
    props: [ 'bp', 'details' ],
    data () {
      return {
        breakpointsPer: null,
        breakpointEntries: []
      }
    },
    computed: {
      breakpoints () {
        return this.sortedOptions('BREAKPOINT_UNIT')
      }
    },
    watch: {
      breakpointsPer (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('updating', { breakpointsPer: newVal, breakpointEntries: this.breakpointEntries })
        }
      },
      breakpointEntries: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            this.$emit('updating', { breakpointsPer: this.breakpointsPer, breakpointEntries: newVal })
          }
        }
      },
      details: {
        deep: true,
        handler: function (newVal, oldVal) {
          for (let prop in newVal) {
            if (this.hasOwnProperty(prop) && JSON.stringify(this[prop]) !== JSON.stringify(newVal[prop])) {
              this[prop] = newVal[prop]
            }
          }
        }
      },
      bp (newVal, oldVal) {
        if (this.breakpointsPer !== newVal && newVal !== oldVal) {
          this.breakpointsPer = newVal
        }
      }
    },
    methods: {
      sortedOptions (type) {
        return this.getSystemOptions(type).sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
      },
      updateSequence () {
        this.breakpointEntries.forEach((o, index) => {
          o.sequence = index + 1
        })
      },
      addRow () {
        this.breakpointEntries.push({
          minimumValue: 0,
          maximumValue: 0,
          category: 'BREAKPOINT_UNIT',
          sequence: null
        })
        this.$emit('updating', { breakpointsPer: this.breakpointsPer, breakpointEntries: this.breakpointEntries })
        this.updateSequence()
      },
      remove (i) {
        this.breakpointEntries.splice(i, 1)
        this.$emit('updating', { breakpointsPer: this.breakpointsPer, breakpointEntries: this.breakpointEntries })
        this.updateSequence()
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// Breakpoints.vue?699eb69c